// extracted by mini-css-extract-plugin
export default {"titulo":"RulesButton_titulo__+1iVy","imagem":"RulesButton_imagem__-H02c"};